<!-- eslint-disable max-len -->
<template>
<svg
    width="140" height="140" viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <circle
        cx="70" cy="70" r="70"
        fill="currentColor"
        fill-opacity="0.96"
    />
    <path
        d="M95.1,52.1c2.1-2.1,2.1-5.5,0-7.5c-2.1-2.1-5.5-2.1-7.5,0L70,62.1L52.4,44.6c-2.1-2.1-5.5-2.1-7.6,0c-2.1,2.1-2.1,5.5,0,7.5 l17.6,17.5L44.9,87.2c-2.1,2.1-2.1,5.5,0,7.5c2.1,2.1,5.5,2.1,7.6,0L70,77.2l17.6,17.5c2.1,2.1,5.5,2.1,7.5,0c2.1-2.1,2.1-5.5,0-7.5 L77.5,69.7L95.1,52.1z" fill="black"
    />
</svg>
</template>
